import React, { Component } from "react"
import moment from "moment"

import Calendar from "app/static/frontend/search-new/containers/Visualization/Calendar/index"
import { toDateTimeString } from "app/static/frontend/imports/desktopHelperFunctions"

import { EventDatePickerStartFilter, EventDatePickerEndFilter } from "shared/search/containers/Filter/EventFilters"

import { DatePickerStartFilter, DatePickerEndFilter } from "shared/search/containers/Filter/Filters"

export default function genericCalendar(props) {
    const getFilterValues = (filters) => ({
        start: filters.get(props.dateStartId) && moment(filters.get(props.dateStartId), "MMMM Do, YYYY"),
        end: filters.get(props.dateEndId) && moment(filters.get(props.dateEndId), "MMMM Do, YYYY"),
    })

    const getFilterKeys = (filterKeys) => ({
        start: filterKeys.get(props.dateStartId),
        end: filterKeys.get(props.dateEndId),
    })

    return (
        <Calendar
            uniqueVizSceneId="calendar"
            getFilterValues={getFilterValues}
            getFilterKeys={getFilterKeys}
            {...props}
        />
    )
}

export class EventCalendar extends Component {
    static defaultProps = {
        quorumDataType: DjangIO.app.models.QuorumDataType.event.value,
        additionalGraphKeys: {},
        onlyFields: [
            "when", // start
            "end", // end
            "plain_subject", // title
            "event_type", // type field
            "region", // region
            "chamber", // chamber
            "is_custom_all_day_event", // is all day
        ],
        dateStartId: EventDatePickerStartFilter.defaultProps.uniqueFilterId,
        dateEndId: EventDatePickerEndFilter.defaultProps.uniqueFilterId,
        // takes in datum (object), returns Javascript object
        convertDatumToCalendarObject: (datum) => {
            // base case of title: subject or event type
            let title =
                datum.plain_subject ||
                DjangIO.app.events.models.EventType.by_value(datum.event_type).label ||
                "Unnamed Event"

            // append chamber and region infomration, if applicable
            if (!Userdata.isSingleRegionMode() && datum.region) {
                const region = datum.region
                const chamber = datum.chamber

                const regionAbbrev = DjangIO.app.models.Region.by_value(region).abbrev.toUpperCase()
                let chamberAbbrev = ""

                switch (chamber) {
                    case DjangIO.app.models.CongressChamber.house.value:
                        chamberAbbrev = DjangIO.app.models.Region.by_value(region)
                            .lower_chamber_title.charAt(0)
                            .toUpperCase()
                        break
                    case DjangIO.app.models.CongressChamber.senate.value:
                        chamberAbbrev = DjangIO.app.models.Region.by_value(region)
                            .upper_chamber_title.charAt(0)
                            .toUpperCase()
                        break
                    case DjangIO.app.models.CongressChamber.both.value:
                        chamberAbbrev = "J"
                        break
                    case DjangIO.app.models.CongressChamber.executive.value:
                        chamberAbbrev = DjangIO.app.models.CongressChamber.executive.label.charAt(0).toUpperCase()
                        break
                }

                title = chamberAbbrev ? `${regionAbbrev} ${chamberAbbrev}: ${title}` : `${regionAbbrev}: ${title}`
            }

            return {
                allDay: datum.is_custom_all_day_event,
                start: moment(datum.when).toDate(),
                end: datum.end ? moment(datum.end).toDate() : moment(datum.when).add(1, "hours").toDate(),
                title,
                id: datum.id,
                styleClass: DjangIO.app.events.models.EventType.by_value(datum.event_type).qcal_class,
            }
        },
        onClick: (obj) => {
            const dateText = toDateTimeString(obj.start, obj.region, obj.allDay)

            return swal({
                title: obj.title,
                text: dateText,
                icon: "info",
                buttons: {
                    cancel: true,
                    confirm: {
                        text: "Download Event",
                    },
                },
            }).then((confirm) => {
                if (confirm) {
                    // download the event!
                    const url = `${window.location.origin}/api/event/${obj.id}/?ics=true`
                    window.location.href = url
                }
            })
        },
        // used for putting a class on `rbc-event`, allowing for different colors
        // per event if desired. eventPropGetter is a prop in BigCalendar.
        eventPropGetter: (eventObj) => ({
            className: `rbc-event ${eventObj.styleClass || ""}`,
        }),
    }

    render() {
        return genericCalendar(this.props)
    }
}

export class NoteCalendar extends Component {
    static defaultProps = {
        quorumDataType: DjangIO.app.models.QuorumDataType.note.value,
        additionalGraphKeys: {
            plain: true, // make sure that there is no markup in the humanized text
        },
        onlyFields: [
            "cache_json", // dehydrate method requires this field
            "date", // start
            // there is no end object
            "humanized_text", // title
            "text", // additional information (user-given comment on what happened)
            "interaction_type", // maybe it's an interaction
            "note_type", // if it's not an interaction, it must have a note type
            "searchable_date", // Humanized date displayed on inline
        ],
        dateStartId: DatePickerStartFilter.defaultProps.uniqueFilterId,
        dateEndId: DatePickerEndFilter.defaultProps.uniqueFilterId,
        convertDatumToCalendarObject: (datum) => {
            const title = datum.humanized_text

            // have the visualization either show: any additional text,
            // or just a filler field of what kind of note it is (interaction,
            // comment, etc.)
            const extraField =
                datum.text ||
                (datum.interaction_type &&
                    DjangIO.app.userdata.types.InteractionType.by_value(datum.interaction_type).label) ||
                DjangIO.app.userdata.types.NoteType.by_value(datum.note_type).label ||
                "Uncategorized"

            return {
                start: moment(datum.searchable_date).toDate(),
                end: moment(datum.searchable_date).add(1, "hours").toDate(),
                id: datum.id,
                title,
                extraField,
            }
        },
        onClick: (obj) => {
            const dateText = toDateTimeString(obj.start)

            const span = document.createElement("span")
            span.innerHTML = obj.extraField

            return swal({
                title: obj.title,
                text: dateText,
                content: span,
            })
        },
    }

    render() {
        return genericCalendar(this.props)
    }
}
